import React from 'react'
import PropTypes from 'prop-types'
import OpalHeading from '../../../../components/opal/OpalHeading'
import FlexRow from '../../../../components/molecules/FlexRow'
import FlexColumn from '../../../../components/molecules/FlexColumn'
import LinkCard from '../common/LinkCard'

function formatIntent (intent) {
  switch (intent) {
    case 'data_inquiry':
      return 'Data Inquiry'
    case 'data_inquiry_with_visuals':
      return 'Data Inquiry with Visualizations'
    case 'general_assistance':
      return 'General Assistance'
    case 'digest_scheduled_prompts':
      return 'Digest'
    default:
      return ''
  }
}

function formatSchedule (schedule) {
  const result = ['Runs']
  switch (schedule.interval) {
    case 'day':
      result.push('daily')
      break
    case 'week':
      result.push('weekly')
      break
    case 'month':
      result.push('monthly')
      break
    default:
      return ''
  }
  result.push('at the')
  result.push(schedule.bound)
  result.push('of the')
  result.push(schedule.interval)

  return result.join(' ')
}

function ScheduleListItem ({ scheduledPrompt }) {
  return (
    <LinkCard to={`/denali-ai/schedules/${scheduledPrompt.scheduleId}`}>
      <FlexColumn className='gap-sm'>
        <FlexRow>
          <OpalHeading className='font-size-md'>{scheduledPrompt.name}</OpalHeading>
        </FlexRow>
        <FlexRow>
          <span className='font-sans font-size-xs'>{formatIntent(scheduledPrompt.configuration.intent)}</span>
        </FlexRow>
        <FlexRow>
          <span className='font-sans font-size-xs'>{formatSchedule(scheduledPrompt.configuration.schedule)}</span>
        </FlexRow>
      </FlexColumn>
    </LinkCard>
  )
}

ScheduleListItem.propTypes = {
  scheduledPrompt: PropTypes.shape({
    scheduleId: PropTypes.string,
    name: PropTypes.string,
    configuration: PropTypes.shape({
      intent: PropTypes.string,
      schedule: PropTypes.shape({
        interval: PropTypes.string,
        bound: PropTypes.string
      })
    })
  })
}

export default ScheduleListItem
